import {
    selectors as bookmakersListSelectors,
} from '../common/bookmakersList'
import {
    actions as bookmakersInfoActions,
    selectors as bookmakersInfoSelectors,
} from '../common/bookmakersInfo'
import {
    actions as loginActions,
} from '../common/loginPage'
import {
    selectors as userInfoSelectors,
} from '../common/userInfo'

const SPECULATIVE_API_NAME = 'speculative'

const dispatchBuildMultiples = (store, apiName, selectedBets, feed, isExternalLogout) => {
    store.dispatch(bookmakersInfoActions.saveMultiplesStakes())
    store.dispatch(bookmakersInfoActions.saveMultiplesEachWay())
    store.dispatch(bookmakersInfoActions.clearMultiples())
    store.dispatch(bookmakersInfoActions.buildMultiplesRequest(true))
    store.dispatch(bookmakersInfoActions.buildMultiples(
        apiName,
        selectedBets,
        feed,
        isExternalLogout,
    ))
}

const getMeta = (store) => {
    const state = store.getState()
    const selectedBookmaker = state.bookmakersInfo.selectedBookmaker
    const feedSelector = () => selectedBookmaker
    const isUserLoggedIn = bookmakersListSelectors
        .createIsLoggedInSelector(feedSelector)(state)
    const selectedBets = state.bookmakersInfo.selectedBets
    const apiName = bookmakersListSelectors
        .createBookmakerApiNameSelector(feedSelector)(state)
    const bookmaker = state.bookmakersList.find(bookie => bookie.feed === selectedBookmaker)
    const userInfo = userInfoSelectors.createUserInfoSelector(
        bookmakersInfoSelectors.betBookmakerSelector,
    )(state)

    return {
        isUserLoggedIn,
        selectedBets,
        apiName,
        feed: selectedBookmaker,
        isExternalLogout: !!bookmaker.isExternalLogout,
        currencySign: userInfo.currencySign,
    }
}

const buildMultiplesMiddleware = store => next =>
    (action) => {
        let meta
        const result = next(action)

        switch (action.type) {
            case bookmakersInfoActions.actionTypes.TOGGLE_MULTIPLES_INCLUSION:
            case bookmakersInfoActions.actionTypes.ADD_SELECTED_BET:
            case bookmakersInfoActions.actionTypes.DELETE_BET:
            case bookmakersInfoActions.actionTypes.CLEAR_SUSPENDED_BETS:
            case bookmakersInfoActions.actionTypes.UPDATE_ALL_BET_PRICES:
            case loginActions.actionTypes.LOGIN_SUCCESS:
                meta = getMeta(store)

                if (meta.selectedBets.length > 1) {
                    const betsToInclude = meta.selectedBets
                        .filter(bet => bet.includeInMultiples)
                    const apiName = (meta.isUserLoggedIn)
                        ? meta.apiName
                        : SPECULATIVE_API_NAME
                    dispatchBuildMultiples(
                        store,
                        apiName,
                        betsToInclude,
                        meta.feed,
                        meta.isExternalLogout,
                        meta.currencySign,
                    )
                } else {
                    store.dispatch(bookmakersInfoActions.clearMultiples())
                }

                break
            default:
        }

        return result;
    }

export default buildMultiplesMiddleware;



// WEBPACK FOOTER //
// /src/js/App/buildmultiples.middleware.js